export const communityAmenities = [
  ["1", "Certified 55+ Community"],
  ["2", "Country Club"],
  ["3", "Curb & Gutter"],
  ["4", "Gated Entrance"],
  ["5", "Golf Available"],
  ["6", "Guarded Entrance"],
  ["7", "Horse/Livestock Allowed"],
  ["8", "Hunting Privileges"],
  ["9", "None"],
  ["10", "Other"],
  ["11", "Planned Unit Development (PUD)"],
  ["12", "Pool Privileges"],
  ["13", "Property Owners Asssociation"],
  ["14", "Sidewalks"],
  ["15", "Street Lights"],
  ["16", "Tennis Available"],
  ["17", "Tennis Privileges"],
];

export const flooringType = [
  ["18", "Carpet"],
  ["19", "Concrete"],
  ["20", "Granite"],
  ["21", "Hardwood"],
  ["22", "Laminate"],
  ["23", "Marble"],
  ["24", "None"],
  ["25", "Other"],
  ["26", "Parquet"],
  ["27", "Porcelain Tile"],
  ["28", "Saltillo Tile"],
  ["29", "Slate"],
  ["30", "Stained Concrete"],
  ["31", "Terrazzo Tile"],
  ["32", "Tile"],
  ["33", "Travertine"],
  ["34", "Vinyl"],
];

export const roof = [
  ["35", "Built-up/Gravel"],
  ["36", "Clay Tile"],
  ["37", "Composition Shingle"],
  ["38", "Concrete Tile"],
  ["39", "Double Roof-Mobile Home"],
  ["40", "Fiberglass Tile"],
  ["41", "Flat"],
  ["42", "Metal"],
  ["43", "None"],
  ["44", "Other"],
  ["45", "Shingle"],
  ["46", "Slate/Tile"],
  ["47", "Wood Shingle/Shake"],
];
export const streetSurface = [
  ["48", "Caliche"],
  ["49", "Dirt"],
  ["50", "Gravel"],
  ["51", "Other"],
  ["52", "Paved"],
];

export const countertops = [
  ["53", "Granite"],
  ["54", "Laminate"],
  ["55", "Other"],
  ["56", "Other Natural Stone"],
  ["57", "Quartz"],
  ["58", "Solid Surface"],
  ["59", "Stone"],
  ["60", "Tile"],
];

export const foundationType = [
  ["61", "Basement"],
  ["62", "Combination"],
  ["63", "Crawl Space"],
  ["64", "Other"],
  ["65", "Pier & Beam"],
  ["66", "Pilings"],
  ["67", "Slab"],
];

export const energyFeatures = [
  ["68", "Attic Fans"],
  ["69", "Double Pane Windows"],
  ["70", "Energy Star"],
  ["71", "Good Cents"],
  ["72", "Green Built"],
  ["73", "None"],
  ["74", "Other"],
  ["75", "Programmable Thermostat"],
  ["76", "Solar Panel Lease"],
  ["77", "Solar Panel Owned"],
  ["78", "Solar Screen"],
  ["79", "Storm Doors"],
  ["80", "Storm Windows"],
];

export const laundry = [
  ["81", "Area"],
  ["82", "Closet"],
  ["83", "Garage"],
  ["84", "Room"],
  ["85", "None"],
];

export const garageCarport = [
  ["86", "Attached"],
  ["87", "Front Entry"],
  ["88", "Golf Cart"],
  ["89", "No Carport"],
  ["90", "No Garage"],
  ["91", "Opener/Control"],
  ["92", "Other"],
  ["93", "Rear Entry"],
  ["94", "Side Entry"],
];

export const specialFeatures = [
  ["95", "1 Year Warranty"],
  ["96", "2-10 Year Warranty"],
  ["97", "Audio/Video Wiring"],
  ["98", "CO Detectors"],
  ["99", "Controlled Access"],
  ["100", "Corporate Rental"],
  ["101", "Furnished"],
  ["102", "Home Warranty"],
  ["103", "In-Wall Pest Control System"],
  ["104", "New Construction"],
  ["105", "None"],
  ["106", "Other"],
  ["107", "Satellite System"],
  ["108", "Security System"],
  ["109", "Underslab Termite System"],
  ["110", "Unfurnished"],
  ["111", "Video Surveillance"],
];

export const mainSuite = [
  ["112", "Bidet"],
  ["113", "Double Vanity"],
  ["114", "Garden Tub"],
  ["115", "His/Her Closet(s)"],
  ["116", "None"],
  ["117", "Other"],
  ["118", "Outside Access"],
  ["119", "Private Commode"],
  ["120", "Seperate Shower"],
  ["121", "Sitting Area"],
  ["122", "Split Bedrooms"],
  ["123", "Tub Only"],
  ["124", "Tub/Shower Combo"],
  ["125", "Upstairs Main"],
  ["126", "Walk-in Closet(s)"],
  ["127", "Whirlpool Jets"],
];

export const exteriorFeatures = [
  ["128", "Balcony"],
  ["129", "BBQ Pit/Grill"],
  ["130", "Boat Dock"],
  ["131", "Boat House"],
  ["132", "Boat Lift"],
  ["133", "Covered Patio"],
  ["134", "Deck"],
  ["135", "Deck/Balcony/Porch"],
  ["136", "Detached Quarters"],
  ["137", "Exercise Room"],
  ["138", "Gazebo"],
  ["139", "Gutters/Spouting"],
  ["140", "Horse Stables/Barn"],
  ["141", "Hot Tub"],
  ["142", "Hurricane Shutters"],
  ["143", "Manual Gate"],
  ["144", "Mature Trees"],
  ["145", "Motorized Gate"],
  ["146", "None"],
  ["147", "Other"],
  ["148", "Patio"],
  ["149", "Patio Slab"],
  ["150", "Pool"],
  ["151", "Private Tennis"],
  ["152", "Rock Yard"],
  ["153", "Sauna"],
  ["154", "Screened Patio"],
  ["155", "Sprinkler System"],
  ["156", "Steam Room"],
  ["157", "Storage Building"],
  ["158", "Workshop"],
];

export const hvac = [
  ["159", "Central"],
  ["160", "Central Zoned"],
  ["161", "Electric"],
  ["162", "Electric Heat Pump"],
  ["163", "Floor"],
  ["164", "Natural Gas"],
  ["165", "No Cooling"],
  ["166", "No Heat"],
  ["167", "None"],
  ["168", "Oil"],
  ["169", "Other"],
  ["170", "Propane/Butane"],
  ["171", "Radiant"],
  ["172", "Solar"],
  ["173", "Space"],
  ["174", "Wall"],
  ["175", "Window"],
];

export const waterHeater = [
  ["176", "Electric"],
  ["177", "Electric Heat Pump"],
  ["178", "Good Cents"],
  ["179", "Natural Gas"],
  ["180", "None"],
  ["181", "Other"],
  ["182", "Programmable Thermostat"],
  ["183", "Propane/Butane"],
  ["184", "Solar Combination"],
  ["185", "Tankless"],
  ["186", "WH-Attic"],
  ["187", "WH-Garage"],
  ["188", "WH-Laundry"],
  ["189", "WH-Other Location"],
];

export const exteriorSiding = [
  ["190", "Adobe"],
  ["191", "Aluminum Sliding"],
  ["192", "Asbestos Siding"],
  ["193", "Brick"],
  ["194", "Concrete Block"],
  ["195", "Frame/Wood"],
  ["196", "Hardy Plank"],
  ["197", "Masonite Sliding"],
  ["198", "None"],
  ["199", "Other"],
  ["200", "Siding"],
  ["201", "Solid Masonry"],
  ["202", "Stone"],
  ["203", "Stucco"],
  ["204", "Tilt Wall Concrete"],
  ["205", "Vinyl Sliding"],
  ["206", "Wood"],
];

export const poolDetails = [
  ["207", "Above Ground"],
  ["208", "Diving Board"],
  ["209", "Heated"],
  ["210", "In Ground"],
  ["211", "Indoor Hot Tub"],
  ["212", "Indoor Pool"],
  ["213", "No Cleaning System"],
  ["214", "Other Cleaning System"],
  ["215", "Other Pool"],
  ["216", "Outdoor Hot Tub"],
  ["217", "Pool Area Fence"],
  ["218", "Valet/Caretaker"],
];

export const interiorFeatures = [
  ["219", "Bay Windows"],
  ["220", "Bonus Rooms"],
  ["221", "Built Ins"],
  ["222", "Cable TV"],
  ["223", "Ceiling Fans"],
  ["224", "Central Vacuum"],
  ["225", "Crown/Cove Molding"],
  ["226", "Decorative/High Ceilings"],
  ["227", "Dryer"],
  ["228", "Fireplace"],
  ["229", "Firewall"],
  ["230", "Intercom"],
  ["231", "Microwave"],
  ["232", "None"],
  ["233", "Office/Study"],
  ["234", "Other"],
  ["235", "Skylight"],
  ["236", "Smoke Alarm(s)"],
  ["237", "Split Bedrooms"],
  ["238", "Walk-in Closet"],
  ["239", "Washer"],
  ["240", "Washer/Dryer Connection"],
  ["241", "Wet/Dry Bar"],
];

export const waterSewer = [
  ["242", "Assessment"],
  ["243", "City Sewer"],
  ["244", "MUD"],
  ["245", "No Sewer"],
  ["246", "Other"],
  ["247", "Private Well"],
  ["248", "Public Water"],
  ["249", "Public Water Available"],
  ["250", "Septic"],
  ["251", "Sewer Avail Not Connected"],
  ["252", "Shared Well"],
];

export const windowCoverings = [
  ["304", "Custom Drapes"],
  ["305", "Drapes/Curtains"],
  ["306", "Mini Blinds"],
  ["307", "No Window Coverings"],
  ["308", "Other"],
  ["309", "Partial Window Coverings"],
  ["310", "Vertical Blinds"],
  ["311", "Wood/Faux Blinds"],
];

export const fenceType = [
  ["312", "Barbed Wire"],
  ["313", "Chain Link"],
  ["314", "Cross Fence"],
  ["315", "Decorative Metal"],
  ["316", "Electric Fence"],
  ["317", "Irrigation"],
  ["318", "Landscaped"],
  ["319", "Masonry"],
  ["320", "Non Privacy"],
  ["321", "None"],
  ["322", "Other"],
  ["323", "Partial"],
  ["324", "Privacy"],
  ["325", "Smooth Wire"],
  ["326", "Vinyl"],
  ["327", "Wood"],
  ["466", "Privacy - Wood"],
  ["467", "Privacy - Masonry"],
  ["468", "Non-Privacy - Chain Link"],
  ["469", "Non-Privacy - Smooth Wire"],
];

export const locationFeatures = [
  ["328", "Alley"],
  ["329", "Bayside"],
  ["330", "Boat Dock"],
  ["331", "Corner Lot"],
  ["332", "Cul-de-Sac Lot"],
  ["333", "Curb & Gutters"],
  ["334", "Fishing Pier"],
  ["335", "Flood Irrigation"],
  ["336", "Gulfside"],
  ["337", "Irregular Lot"],
  ["338", "Mature Trees"],
  ["339", "None"],
  ["340", "On Golf Course"],
  ["341", "On Waterfront"],
  ["342", "Other"],
  ["343", "Professional Landscaping"],
  ["344", "Resaca"],
  ["345", "Sidewalks"],
  ["346", "Sprinkler System"],
];

export const conveyingAppliances = [
  ["347", "Cooktop-Electric Coil"],
  ["348", "Cooktop-Electric Smooth"],
  ["349", "Cooktop-Gas"],
  ["350", "Dishwasher"],
  ["351", "Disposal"],
  ["352", "Dryer"],
  ["353", "Ice Maker"],
  ["354", "Microwave Oven"],
  ["355", "No Conveying Appliances"],
  ["356", "Other"],
  ["357", "Oven-Convection"],
  ["358", "Oven-Double"],
  ["359", "Oven-Microwave"],
  ["360", "Oven-Single"],
  ["361", "Oven-Warming"],
  ["362", "Refrigerator"],
  ["363", "Refrigerator Built-in"],
  ["364", "Stove/Range"],
  ["365", "Stove/Range-Electric Coil"],
  ["366", "Stove/Range-Electric Smooth"],
  ["367", "Stove/Range-Gas"],
  ["368", "Trash Compactor"],
  ["369", "Washer"],
  ["370", "Wine Cooler"],
];

export const docsOnFile = [
  ["371", "Aerial Survey"],
  ["372", "Appraisal"],
  ["373", "Boundary Survey"],
  ["374", "Building Restrictions"],
  ["375", "Cash Flow"],
  ["376", "Deed"],
  ["377", "Deed Restrictions"],
  ["378", "Demographics"],
  ["379", "EPA Documents"],
  ["380", "Equipment List"],
  ["381", "Feasibility Study"],
  ["382", "Feasibility"],
  ["383", "Floor Plan"],
  ["384", "Inventory List"],
  ["385", "Lease Documents"],
  ["386", "New Survey Lines Marked"],
  ["387", "None"],
  ["388", "Other"],
  ["389", "Perc Test"],
  ["390", "Profit & List"],
  ["391", "Site Plan"],
  ["392", "Soil Survey"],
  ["393", "Survey"],
  ["394", "Survey/Plat"],
  ["395", "Topo Map"],
  ["396", "Traffic Flow"],
];

export const other = [["470", "ADA Accessible"]];
